import { StyledProps } from '@front10';
import { Context } from '@front10/helpers/dist/Context';
import React, { useContext } from 'react';
import Text from '../../../elements/Text';

interface Props {
  content?: string;
}

/**
 * ## Example
 * ```js
<Separator
  content="bar"
/> 
 * ```
 */

function Separator({
  content = 'bar',
  paddingRight = '1',
  paddingLeft = '1',
  ...props
}: StyledProps<Props>) {
  const { translate } = useContext(Context);

  return (
    <Text paddingLeft={paddingLeft} paddingRight={paddingRight} {...props}>
      {content !== '' && translate(`cmp-separator-${content}`, content)}
    </Text>
  );
}

Separator.componentName = 'Separator';

export default Separator;
